import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";

const CompanyScreen = () => {
  const { requestCompany, setRequestCompany, resultCompany, showModal } =
    React.useContext(Context.CompanyScreen);

  return (
    <CustomView.Container id="driver-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          <Components.Create />

          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.COMPANY_HEADERS} />
          {resultCompany?.status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={resultCompany?.data?.result?.docs} />
          )}
        </table>
      </div>
      {resultCompany?.status === "success" &&
        resultCompany?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestCompany?.page}
              totalPages={resultCompany?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestCompany!({ ...requestCompany, page })
              }
            />
          </div>
        )}
      <Components.Detail />
      <Components.Delete />
      <Components.Update />
    </CustomView.Container>
  );
};

export default CompanyScreen;
